import { create } from 'zustand';

// Store slices
import createConnectionSlice from './slices/connectionSlice';
import createCallSlice from './slices/callSlice';
import createUserSlice from './slices/userSlice';
import createMediaSlice from './slices/mediaSlice';
import createScreenshotSlice from './slices/screenshotSlice';
import createRecordingSlice from './slices/recordingSlice';
import createNotesSlice from './slices/notesSlice';
import createAgentStatusSlice from './slices/agentStatusSlice';
import createNotificationSlice from './slices/notificationSlice';
import createCallOutcomeSlice from './slices/callOutcomeSlice';

// Ana store oluşturucu
const useStore = create((set, get) => ({
    // Her slice'ı ekle
    ...createConnectionSlice(set, get),
    ...createCallSlice(set, get),
    ...createUserSlice(set, get),
    ...createMediaSlice(set, get),
    ...createScreenshotSlice(set, get),
    ...createRecordingSlice(set, get),
    ...createNotesSlice(set, get),
    ...createAgentStatusSlice(set, get),
    ...createNotificationSlice(set, get),
    ...createCallOutcomeSlice(set, get),
}));

export default useStore;
